import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {
  makeStyles,
  ThemeProvider,
  createMuiTheme,
  useTheme,
} from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import theBG from "../../../assets/images/food2.png";
import AOS from "aos";
import "aos/dist/aos.css";
import GrabButton from "../../Button/GrabButton";

const useStyles = makeStyles((theme) => ({
  bg: {
    width: "100%",
    height: "100vh",
    color: "white",
  },
}));

const serifFont = createMuiTheme({
  typography: {
    fontFamily: ["Old Standard TT", "serif"].join(","),
  },
});

export default function Body() {
  const classes = useStyles();
  const theme = useTheme();
  useEffect(() => {
    AOS.init({});
  }, []);
  return (
    <Card className={classes.bg}>
      <CardMedia component="img" alt="Contemplative Reptile" image={theBG} />
      <Grid container className={classes.bg}>
        <Grid
          item
          data-aos="flip-left"
          data-aos-duration="1000"
          style={{
            position: "absolute",
            right: "5rem",
            top: "10rem",
            padding: "1rem",
            borderStyle: "solid",
            borderWidth: "5px",
            backgroundColor: "transparent",
            fontStyle: "italic",
            boxSizing: "border-box",
            borderColor: "#996f32",
          }}
        >
          <ThemeProvider theme={serifFont}>
            <Typography variant="h6" paragraph style={{ color: "#996f32" }}>
              Bước vào bên trong Bún bò O Như, ban ngày biến thành màn đêm,
              <br />
              mùa hè sang mùa đông với nhiều bún và thịt bắp bò tươi.
            </Typography>
          </ThemeProvider>
        </Grid>
        <Grid
          item
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <ThemeProvider theme={serifFont}>
            <Typography
              variant="h3"
              style={{ fontWeight: "bold" }}
              data-aos="zoom-in"
              data-aos-duration="1000"
            >
              Bún Bò O Như
            </Typography>
          </ThemeProvider>
        </Grid>
        <Grid
          item
          direction="column"
          alignItems="center"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, 60%)",
            display: "flex",
          }}
        >
          <GrabButton />
          <Typography
            variant="h6"
            style={{
              padding: theme.spacing(2),
              fontWeight: "bold",
            }}
          >
            HOẶC
          </Typography>
          <Typography variant="h5">
            <a
              href="https://www.google.com/maps/place/B%C3%BAn+B%E1%BA%AFp+B%C3%B2+O+Nh%C6%B0/@10.7400125,106.6757078,17z/data=!4m13!1m7!3m6!1s0x31752faceb2a9621:0x54ec2b6171781878!2zMTM0IMSQxrDhu51uZyBDYW8gTOG7lywgUGjGsOG7nW5nIDQsIFF14bqtbiA4LCBUaMOgbmggcGjhu5EgSOG7kyBDaMOtIE1pbmg!3b1!8m2!3d10.7400125!4d106.6778965!3m4!1s0x31752fcbf2b71fef:0xff4b8413fe51f530!8m2!3d10.7400125!4d106.6778965"
              target="_blank"
              rel="noreferrer"
              style={{ color: "white", textTransform: "uppercase" }}
            >
              Ăn tại quán!
            </a>
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
}
